<template>
  <FormulateInput
    class="p-0"
    v-bind="field"
    validation-behavior="live"
    :name="`${field.name}-${id}-${index}`"
    :label="null"
    :help="true"
    :value="computedValue"
    :fullObject="fullObject"
    @input="handleInput"
    @update:fullObject="$emit('update:fullObject', $event)"
  />
</template>

<script>
export default {
  props: {
    value: {},
    field: {},
    fullObject: {},
    id: {},
    index: {},
  },
  emits: ['input', 'update:fullObject'],
  computed: {
    computedValue() {
      // if it's empty, always return null
      if (this.value === '' || this.value === false) return null

      return this.value
    },
  },
  methods: {
    handleInput(newValue) {
      // if newValue is empty, always set null
      if (newValue === '' || newValue === false || newValue === undefined) {
        this.$emit('input', null)
        return
      }

      // nothing happened when newValue is null
      if (newValue === null) return

      // if newValue has same value with other address field
      if (newValue == this.otherAdressFullObject?.id) {
        this.$mcToast.error('Alamat Tujuan tidak boleh sama dengan Alamat Asal')
        this.$emit('input', null)
        this.$emit('update:fullObject', {})
        return
      }

      this.$emit('input', newValue)
    },
  },
}
</script>
